export default __webpack_public_path__ + "static/media/luis.1323d314.png";